import type { ApiConfig } from '../../types'

export const spotTradeHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'asc',
  range: undefined,
  requiresRange: true,
  type: 'spot-trade-history',
} as const satisfies ApiConfig
